/* eslint-disable */

var root = this;

var Logger = function (context, options) {
    options = options || {};
    this.context = context || "No Context";
    this.root = (!!window) ? window : root;
    this.mode = options.mode || Logger.defaults.mode;
    this.cookieName = options.cookieName || Logger.defaults.cookieName;
    this.level = 'log';
};

Logger.defaults = {
    mode: 'cookie',
    cookieName: 'ckps_notifications_log'
};

Logger.getLogger = function(context, options) {
    return new this(context, options);
};

function log(level) {
    var args;

    if (this.root.console && this.isLoggingEnabled()) {

        args = (arguments.length > 0) ? Array.prototype.slice.call(arguments, 1) : [];
        level = level.toLowerCase();

        this.level = (typeof this.root.console[level] === 'function') ? level : 'log';

        args[0] = this.getLogTitle() + ' ' + args[0];
        if (this.root.console[this.level].apply) {
            this.root.console[this.level].apply(this.root.console, args);
            // Edge cases (e.g IE)
        } else if (this.root.console.log) {
            this.root.console.log(args);
        }
    }
}

function prepareArgs(level, rawArgs) {
    var newArgs;
    rawArgs = rawArgs || [];

    newArgs = Array.prototype.slice.call(rawArgs);
    newArgs.unshift(level);
    return newArgs;
}

Logger.prototype = {

    log: function() {
        log.apply(this, prepareArgs('log', arguments));
    },

    info: function() {
        log.apply(this, prepareArgs('info', arguments));
    },

    error: function() {
        log.apply(this, prepareArgs('error', arguments));
    },

    warn: function() {
        log.apply(this, prepareArgs('warn', arguments));
    },

    debug: function() {
        log.apply(this, prepareArgs('debug', arguments));
    },

    getLogTitle: function() {
        return ['[', this.context, ':', this.level.toUpperCase(), ']'].join('');
    },

    isLoggingEnabled: function() {
        if (this.mode === 'cookie') {
            // The logging cookie must be present
            return document.cookie.indexOf(this.cookieName) !== -1;
        } else {
            // Any other mode has logging enabled
            return true;
        }
    }
};

module.exports = Logger;



/** WEBPACK FOOTER **
 ** ./assets/js/logger.js
 **/